import { render, staticRenderFns } from "./CommercialPolicies.vue?vue&type=template&id=5be4350f&scoped=true"
import script from "./CommercialPolicies.vue?vue&type=script&lang=js"
export * from "./CommercialPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4350f",
  null
  
)

export default component.exports